import React from 'react';

var useSafeLayoutEffect = {};

Object.defineProperty(useSafeLayoutEffect, "__esModule", { value: true });
var useSafeLayoutEffect_1 = useSafeLayoutEffect.useSafeLayoutEffect = void 0;
const react_1 = React;
useSafeLayoutEffect_1 = useSafeLayoutEffect.useSafeLayoutEffect = (globalThis === null || globalThis === void 0 ? void 0 : globalThis.document)
    ? react_1.useLayoutEffect
    : react_1.useEffect;

export { useSafeLayoutEffect as a, useSafeLayoutEffect_1 as u };
